<template>
  <div id="app">
    <headerNav></headerNav>

    <!-- include header component -->
    <!-- <div id="nav">
      <router-link to="/">Home</router-link>|
      <router-link to="/about">About</router-link>
    </div>-->
    <router-view/>

    <!-- include footer component -->
    <footerComp></footerComp>

    
  </div>
  
</template>
<script>
import headerNav from "@/components/headerNav.vue";
import footerComp from "@/components/footerComp.vue";
/* eslint-disable */
export default {
  components: {
    headerNav,
    footerComp
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
}
</style>
